export default __webpack_public_path__ + "static/media/left-1.4f103f45.jpg";